export default "__VITE_ASSET__667b7f49__"